<template>
 <!-- 凭证 -->
  <el-dialog  title="凭证"  :visible.sync="dialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div>
        <div class="addressBox" style="margin-bottom:20px"  v-if="imgList.loadingImgs.length>0">
          <h4 class="title">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>装车凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in imgList.loadingImgs" :src="item.fileUrlOSS" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,loadingImgs)">
                </el-image>
            </div>
          <div><span style="margin-right: 46px;">上传人：{{imgList.loadingImgs[0].createUserName}}</span><span>上传时间：{{imgList.loadingImgs[0].createTime|dateFormat}} </span></div>
        </div>
         <div class="addressBox" v-if="imgList.unloadImgs.length>0">
          <h4 class="title">
            <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>卸车凭证</span>
          </h4>
           <div class="imgBox">
                <el-image
                 v-for="(item,index) in imgList.unloadImgs" :src="item.fileUrlOSS" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,unloadImgs)">
                </el-image>
            </div>
          <div><span style="margin-right:46px;">上传人：{{imgList.unloadImgs[0].createUserName}}</span><span>上传时间：{{imgList.unloadImgs[0].createTime|dateFormat}} </span></div>
        </div>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
      </span>
   </el-dialog>

</template>

<script>
import { wayListImgs } from '@/api/soc-customer'
export default {
  name: 'lookVoucher',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: false,
      imgList: {
        loadingImgs: [],
        unloadImgs: []
      },
      loadingImgs: [],
      unloadImgs: []

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowData) {
      this.dialog = true
      wayListImgs({ wayId: this.rowData.id }).then(res => {
        this.imgList = res
        res.loadingImgs.forEach(item => {
          this.loadingImgs.push(item.fileUrlOSS)
        })
        res.unloadImgs.forEach(item => {
          this.unloadImgs.push(item.fileUrlOSS)
        })
      })
    }
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
